import { FilterAlt } from '@mui/icons-material'
import {
  Autocomplete,
  type AutocompleteRenderInputParams,
  Button,
  Popover,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { ScheduleOption } from 'src/features/monitoringDashboardAlpha/detail/types'

type Props = {
  options: ScheduleOption[]
  /** 現在選択中のスケジュール UUID */
  value: string[]
  /** 適用時に呼ばれる */
  onChange: (scheduleUuids: string[]) => void
}

/**
 * スケジュールで絞り込むためのドロップダウン（L2 用）
 */
export const ScheduleFilterDropDown = ({ options, value, onChange }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = anchorEl !== null

  const [selected, setSelected] = useState<string[]>(value)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- PlaceFilterDropDown と同様のパターン
    setSelected(value)
  }, [value])

  const isFilterOn = value.length > 0

  const applyFilter = () => {
    onChange(selected)
    setAnchorEl(null)
  }

  const resetFilter = () => {
    setSelected([])
    onChange([])
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        color={isFilterOn ? 'filtered' : 'secondary'}
        variant="outlined"
        startIcon={<FilterAlt />}
        onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
      >
        スケジュールで絞り込む: {isFilterOn ? `${value.length}件` : '全て'}
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{
          // 選択チップが増えても画面外に隠れないよう高さを制限してスクロールさせる
          paper: {
            sx: {
              padding: 2,
              width: '100%',
              maxWidth: 400,
              maxHeight: '80vh',
              overflowY: 'auto',
            },
          },
        }}
      >
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Typography variant="subtitle1">スケジュール名</Typography>
            <Autocomplete
              multiple
              size="small"
              options={options}
              isOptionEqualToValue={(option, val) => option.uuid === val.uuid}
              getOptionLabel={option => option.name}
              value={options.filter(option => selected.includes(option.uuid))}
              onChange={(_, selectedOptions) =>
                setSelected(selectedOptions.map(option => option.uuid))
              }
              slotProps={{ chip: { size: 'small' } }}
              renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField {...params} placeholder="スケジュールを選択" />
              )}
            />
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="flex-end">
            <Button onClick={resetFilter} variant="outlined" color="primary">
              リセット
            </Button>
            <Button variant="contained" color="primary" onClick={applyFilter}>
              適用
            </Button>
          </Stack>
        </Stack>
      </Popover>
    </>
  )
}
